<template>
  <div>
    <v-container
      grid-list-lg
      class="word-wrap pa-0 ma-0 pb-15"
      style="max-width: 100% !important"
    >
      <!-- Banner -->
      <v-layout class="pa-0 ma-0">
        <v-parallax
          height="554"
          style="width: 100%"
          dark
          :src="require('../../../public/images/academy.jpeg').default"
        >
          <v-row align="center" justify="center" class="academyBannerContainer">
            <v-col
              class="text-center"
              col="12"
              style="max-width: 600px; position: relative"
            >
              <!-- Title -->
              <v-img
                :src="require('@/../public/images/kep.png')"
                style="
                  width: 50px;
                  height: 50px;
                  position: absolute;
                  top: 0;
                  left: 0;
                "
              ></v-img>
              <div
                class="white--text font-weight-regular"
                style="font-size: 42px; letter-spacing: -0.02em"
              >
                <span class="font-weight-black">{{
                  $t('title.batAcademi')
                }}</span
                >{{ $t('title.welcomeAcademy') }}
              </div>

              <!-- Subtitle -->
              <!-- <div
                class="white--text font-weight-regular px-5 mt-4"
                style="font-size: 13px"
              >
                {{ $t("title.academySubtitle") }}
              </div> -->

              <!-- Search -->
              <!-- <div class="mt-6 mx-8 whiteInput">
                <v-text-field
                  class="whiteInput"
                  v-model="searchTextModel"
                  :label="$t('labels.searchAcademy')"
                  v-on:keyup.enter="searchText"
                  clearable
                  hide-details="auto"
                  clear-icon="mdi-close-circle"
                  append-icon="mdi-magnify"
                  @click:clear="clearSearch"
                  @click:append="searchText"
                  outlined
                  color="white"
                  rounded
                >
                </v-text-field>
              </div> -->

              <!-- Or -->
              <!-- <div
                class="white--text font-weight-regular px-5 mt-4"
                style="font-size: 15px"
              >
                {{ $t('title.or') }}
              </div> -->

              <!-- Categories -->
              <!-- <div class="mt-4">
                <category-menu
                  :items="categories"
                  :loading="categoryLoading"
                  :buttonName="'Kategori Seç'"
                  @clickMenu="(n) => clickCategory(n)"
                />
              </div> -->
            </v-col>
          </v-row>
        </v-parallax>
      </v-layout>

      <v-flex xs12 md12 class="mt-5">
        <v-layout class="flex flex-wrap justify-center">
          <!-- First Card -->
          <v-flex xs12 sm6 md4 lg3 xl2 class="mb-4 md:mb-0">
            <v-card
              @click="
                () => {
                  this.goAssigned();
                }
              "
              class="rounded-lg shadow-lg h-full py-5 px-8 d-flex flex-column"
              style="width: 100%; height: 250px; background-color: #0051a4"
            >
              <h4
                style="color: white; font-size: 32px"
                class="d-flex flex-column h-full text-center mb-4"
              >
                {{ $t('title.assignedToYou') }}
              </h4>
              <p
                style="color: white; font-size: 16px"
                class="d-flex flex-column h-full text-center"
              >
                {{ $t('title.assignedToYouDesc') }}
              </p>
              <v-img
                :src="magnifyPath"
                style="
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  bottom: 10px;
                  right: 10px;
                "
              ></v-img>
            </v-card>
          </v-flex>

          <!-- Second Card -->
          <v-flex xs12 sm6 md4 lg3 xl2 class="mb-4 md:mb-0">
            <v-card
              @click="
                () => {
                  this.$router.push({
                    path: `/academyCategories`,
                  });
                }
              "
              class="rounded-lg shadow-lg h-full py-10 px-8 d-flex flex-column"
              style="width: 100%; height: 250px; background-color: #ff9400"
            >
              <h4
                style="color: white; font-size: 32px"
                class="d-flex flex-column h-full text-center mb-4"
              >
                {{ $t('title.BATAcademyEducations') }}
              </h4>
              <p
                style="color: white; font-size: 16px"
                class="d-flex flex-column h-full text-center"
              >
                {{ $t('title.BATAcademyEducationsDesc') }}
              </p>
              <v-img
                :src="bookPath"
                style="
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  bottom: 10px;
                  right: 10px;
                  transform: rotate(25deg);
                "
              ></v-img>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 md12>
        <v-layout class="flex flex-wrap justify-center">
          <!-- First Card -->
          <v-flex xs12 sm12 md8 lg6 xl4 class="mb-4 md:mb-0">
            <v-card
              @click="
                () => {
                  this.$router.push({
                    path: `/certificates`,
                  });
                }
              "
              class="rounded-lg shadow-lg h-full px-8 d-flex flex-column justify-center align-center"
              style="width: 100%; height: 250px; background-color: #009800"
            >
              <h4
                style="color: white; font-size: 32px"
                class="d-flex flex-column h-full text-center mb-4"
              >
                {{ $t('title.certificates') }}
              </h4>
              <p
                style="color: white; font-size: 16px"
                class="d-flex flex-column h-full text-center"
              >
                {{ $t('title.certificatesDesc') }}
              </p>
              <v-img
                :src="notebookPath"
                style="
                  width: 40px;
                  height: 40px;
                  position: absolute;
                  bottom: 10px;
                  right: 10px;
                  transform: rotate(15deg);
                "
              ></v-img>
            </v-card>
          </v-flex>
        </v-layout>
      </v-flex>

      <!-- Popular Category -->
      <!-- <v-layout
        row
        wrap
        justify-center
        class="mt-10"
        v-if="categories.length > 0"
      >
        <v-flex xs12 md12>
          <div style="max-width: 1355px; margin-left: auto; margin-right: auto">
            <h4 style="font-size: 24px" class="ml-10 defaultColor--text">
              Popüler Kategoriler
            </h4>
            <v-slide-group class="my-5" active-class="success" show-arrows>
              <v-slide-item
                v-for="(item, i) in categories"
                :key="i"
                class="mr-5"
              >
                <popular-category
                  :item="item"
                  @selectCategory="(n) => clickCategory(n)"
                />
              </v-slide-item>
            </v-slide-group>
          </div>
        </v-flex>
      </v-layout> -->

      <!-- Contents -->
      <v-layout
        v-for="(contentItem, i) in contentItems"
        :key="i"
        row
        wrap
        justify-center
      >
        <v-flex v-if="contentItem.items.length > 0" xs12 md12>
          <div>
            <div class="d-flex mx-10 justify-space-between">
              <h4 style="font-size: 24px" class="defaultColor--text">
                {{ contentItem.title }}
              </h4>
            </div>
            <v-slide-group class="my-5" active-class="success" show-arrows>
              <v-slide-item
                v-for="(item, i) in contentItem.items"
                :key="i"
                class="mr-5"
              >
                <content-card :item="item" />
              </v-slide-item>
            </v-slide-group>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import PopularCategory from '../../components/Academy/PopularCategory.vue';
import ContentCard from '../../components/Academy/ContentCard.vue';
import CategoryMenu from '../../components/Academy/CategoryMenu.vue';
import PostService from '../../services/PostService';
import CategoryService from '../../services/CategoryService';
export default {
  data: function () {
    return {
      bookPath: require('../../../public/images/book.png').default,
      magnifyPath: require('../../../public/images/magnify.png').default,
      notebookPath: require('../../../public/images/notebook.png').default,
      searchTextModel: '',
      contentItems: [
        {
          title: this.$t('title.vizgoContent'),
          items: [],
        },
        {
          title: this.$t('title.lastVideo'),
          items: [],
        },
        {
          title: this.$t('title.lastDocuments'),
          items: [],
        },
        {
          title: this.$t('title.mostLiked'),
          items: [],
        },
      ],

      categories: [],
      categoryLoading: false,

      page: 1,
      pageSize: 10,
    };
  },
  components: {
    PopularCategory,
    ContentCard,
    CategoryMenu,
  },
  methods: {
    goAssigned() {
      this.$router.push({
        name: 'vizgoCategoryDetail',
        params: { id: 1 },
      });
    },
    searchText() {
      this.$router.push({
        path: `/academySearch`,
        query: { searchText: this.searchTextModel },
      });
    },

    clearSearch() {},

    getCategories() {
      //TODO: Burada servis ID ile çalışmamalı, key benzeri parametre ile çalışmalı
      let id = '62a1aa366e569d6087ec1b68';
      this.categoryLoading = true;

      CategoryService.getCategories(id)
        .then((res) => {
          if (res.data) {
            this.categories = res.data.Children;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          this.categoryLoading = false;
        });
    },

    clickCategory(item) {
      console.log('click kategory:', item);
      this.$router.push({
        path: `/academySearch`,
        query: { selectCategory: item },
      });
    },

    getAcademyLastContent(type = '') {
      setPageLoading(true);
      PostService.getAcademyLastContent(this.page, this.pageSize, type)
        .then((res) => {
          switch (type) {
            // case 'video':
            //   this.contentItems[1].items = res.data.Data;
            //   break;
            // case 'document':
            //   this.contentItems[2].items = res.data.Data;
            //   break;
            case '':
              this.contentItems[3].items = res.data.Data;
              break;
            default:
              break;
          }
        })
        .catch((err) => {
          console.log(err);
          showError(err);
        })
        .then(() => {
          setPageLoading(false);
        });
    },
  },
  computed: {},
  destroyed() {},
  mounted() {
    this.getCategories();
    this.getAcademyLastContent('video');
    this.getAcademyLastContent('document');
    this.getAcademyLastContent();
  },
  watch: {},
};
</script>

<style>
.academyBannerContainer {
  background-color: rgba(16, 42, 98, 0.76);
}

.whiteInput > .v-text-field fieldset,
.v-text-field .v-input__control,
.v-text-field .v-input__slot {
  /* border-color: white !important;
  color: white !important; */
}

.whiteInput
  > .v-input__control
  > .v-input__slot
  > .v-text-field__slot
  > .theme--light.v-label {
  color: #ffffff !important;
  font-weight: 500 !important;
}

.whiteInput > .v-input__control > .v-input__slot > .v-text-field__slot > input {
  color: white !important;
}
</style>
